import { getAccessToken } from "../tokenService";

const GRAPH_BASE_URL = "https://graph.microsoft.com/v1.0";

// Reusable graph API caller
const callGraphApi = async (endpoint, accessToken) => {
  const response = await fetch(`${GRAPH_BASE_URL}${endpoint}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!response.ok) {
    throw new Error(`Graph API error on ${endpoint}: ${response.status}`);
  }

  return response;
};

// Get user profile info from Microsoft Graph
export const getUserProfile = async () => {
  const token    = await getAccessToken();
  const response = await callGraphApi("/me", token);
  return response.json();
};

// Get user profile photo as blob URL - returns null if no photo exists
export const getUserPhoto = async () => {
  try {
    const token    = await getAccessToken();
    const response = await callGraphApi("/me/photo/$value", token);
    const blob     = await response.blob();
    return URL.createObjectURL(blob);
  } catch {
    // Photo is optional - return null if not found
    return null;
  }
};

// Get both profile and photo together
export const getFullUserProfile = async () => {
  const [profile, photoUrl] = await Promise.all([
    getUserProfile(),
    getUserPhoto(),
  ]);
  return { ...profile, photoUrl };
};